import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";

import SectionFigure from "../../../assets/images/coming-soon-figure.png";

const ComingSoonSection = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "goHirePage" });

  const proFeatures = [
    {
      title: t("buildYourHiringJourney"),
      subtitle: t("withGoalngoHiringJourney"),
    },
    {
      title: t("amplifyYourReachWithJobBoost"),
      subtitle: t("useGoReach"),
    },
  ];

  return (
    <Box sx={styles.container} component="section">
      <Box sx={styles.proFeaturesContainer}>
        {proFeatures.map(({ title, subtitle }) => (
          <ProSection key={title} title={title} subtitle={subtitle} />
        ))}
      </Box>
      <Box component="img" src={SectionFigure} alt="Post Football Jobs" sx={styles.sectionFigure} />
    </Box>
  );
};

export default ComingSoonSection;

const ProSection = ({ title, subtitle }: { title: string; subtitle: string }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "goHirePage" });

  return (
    <Box sx={styles.content}>
      <Chip label={t("proFeatures")} sx={styles.proFeatureChip} />
      <Typography sx={styles.title}>{title}</Typography>
      <Typography sx={styles.subtitle}>{subtitle}</Typography>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-endv ",
    borderRadius: "12px",
    border: "1px solid var(--Gray-200, #EAECF0)",
    padding: "24px",
    background:
      "linear-gradient(180deg, rgba(143, 255, 60, 0.08) 0%, rgba(143, 255, 60, 0.00) 30.21%, rgba(143, 255, 60, 0.00) 100%), #FFF",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  proFeatureChip: {
    width: "fit-content",
    color: "var(--goalngo-colors-goalngo-colors-r-157-g-0-b-236, #9D00EC)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "16px",
    border: "1px solid #F1D6FF",
    background: "#FCF5FF",
    padding: "4px 12px",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "30px",
  },
  subtitle: {
    color: "var(--Gray-Gray-700, #5E6278)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },

  proFeaturesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: { xs: "100%", md: "406px" },
  },

  sectionFigure: {
    display: { xs: "none", md: "block" },
    width: "330px",
    height: "255px",
  },
};
